import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ComoTrabajamos = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-24 md:pt-32 pb-12 md:pb-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16 relative z-10">
          <div className="text-center">
            <div className="inline-block bg-white/10 backdrop-blur-sm px-4 md:px-6 py-2 rounded-full mb-4 md:mb-6">
              <span className="text-white/90 text-xs md:text-sm font-semibold tracking-wide uppercase">
                Proceso Transparente y Eficiente
              </span>
            </div>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6">Cómo Trabajamos</h1>
            <p className="text-base md:text-xl lg:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed px-4">
              Un proceso simple, rápido y confiable diseñado para que tu empresa nunca se quede sin los insumos que necesita
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mt-10 md:mt-16 max-w-4xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 md:p-6 border border-white/20">
                <div className="text-3xl md:text-4xl font-bold text-white mb-2">4</div>
                <div className="text-white/80 text-sm">Pasos Simples</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 md:p-6 border border-white/20">
                <div className="text-3xl md:text-4xl font-bold text-white mb-2">&lt;48h</div>
                <div className="text-white/80 text-sm">Tiempo de Entrega</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 md:p-6 border border-white/20">
                <div className="text-3xl md:text-4xl font-bold text-white mb-2">100%</div>
                <div className="text-white/80 text-sm">Transparencia</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Proceso en 4 Pasos */}
      <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="text-center mb-20 transition-all duration-1000 opacity-100 translate-y-0">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Proceso de Suministro en 4 Pasos</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Desde tu requisición hasta la entrega con factura, todo está diseñado para tu comodidad
            </p>
          </div>
          
          {/* Desktop View */}
          <div className="hidden lg:block">
            <div className="relative">
              <div className="absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-blue-600 via-blue-800 to-blue-950 transform translate-y-1/2"></div>
              <div className="grid grid-cols-4 gap-8 relative z-10">
                {/* Paso 1 */}
                <div className="transition-all duration-700 opacity-100 translate-y-0">
                  <div className="bg-blue-50 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 h-full border-2 border-blue-200">
                    <div className="inline-block bg-gradient-to-r from-blue-600 to-blue-700 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
                      PASO 01
                    </div>
                    <div className="w-20 h-20 bg-blue-700 rounded-xl flex items-center justify-center mb-6 mx-auto shadow-lg">
                      <i className="ri-file-list-3-line text-4xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center">Requisición</h3>
                    <p className="text-blue-700 font-semibold text-center mb-4">Envía tu lista</p>
                    <div className="inline-block bg-white border-2 border-blue-700 text-blue-700 px-4 py-2 rounded-full text-sm font-bold mb-6 w-full text-center">
                      <i className="ri-time-line mr-2"></i>Inmediato
                    </div>
                    <p className="text-gray-700 leading-relaxed text-center text-sm">
                      Comparte tu lista de productos por WhatsApp, correo electrónico o nuestro formulario web. Aceptamos cualquier formato: Excel, PDF, foto o texto.
                    </p>
                  </div>
                </div>
                
                {/* Paso 2 */}
                <div className="transition-all duration-700 opacity-100 translate-y-0">
                  <div className="bg-blue-100 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 h-full border-2 border-blue-200">
                    <div className="inline-block bg-gradient-to-r from-blue-700 to-blue-800 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
                      PASO 02
                    </div>
                    <div className="w-20 h-20 bg-blue-800 rounded-xl flex items-center justify-center mb-6 mx-auto shadow-lg">
                      <i className="ri-calculator-line text-4xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center">Cotización</h3>
                    <p className="text-blue-700 font-semibold text-center mb-4">Recibe precios</p>
                    <div className="inline-block bg-white border-2 border-blue-700 text-blue-700 px-4 py-2 rounded-full text-sm font-bold mb-6 w-full text-center">
                      <i className="ri-time-line mr-2"></i>24-48 horas
                    </div>
                    <p className="text-gray-700 leading-relaxed text-center text-sm">
                      Buscamos los mejores productos y precios del mercado para ti. Te enviamos una cotización detallada con opciones competitivas, disponibilidad y condiciones de pago adaptadas a tu empresa.
                    </p>
                  </div>
                </div>
                
                {/* Paso 3 */}
                <div className="transition-all duration-700 opacity-100 translate-y-0">
                  <div className="bg-blue-200 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 h-full border-2 border-blue-200">
                    <div className="inline-block bg-gradient-to-r from-blue-800 to-blue-900 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
                      PASO 03
                    </div>
                    <div className="w-20 h-20 bg-blue-900 rounded-xl flex items-center justify-center mb-6 mx-auto shadow-lg">
                      <i className="ri-checkbox-circle-line text-4xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center">Confirmación</h3>
                    <p className="text-blue-700 font-semibold text-center mb-4">Aprueba tu pedido</p>
                    <div className="inline-block bg-white border-2 border-blue-700 text-blue-700 px-4 py-2 rounded-full text-sm font-bold mb-6 w-full text-center">
                      <i className="ri-time-line mr-2"></i>15 minutos
                    </div>
                    <p className="text-gray-700 leading-relaxed text-center text-sm">
                      Revisa y confirma tu pedido. Ofrecemos múltiples formas de pago: transferencia, efectivo y crédito empresarial hasta 30 días.
                    </p>
                  </div>
                </div>
                
                {/* Paso 4 */}
                <div className="transition-all duration-700 opacity-100 translate-y-0">
                  <div className="bg-blue-300 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 h-full border-2 border-blue-200">
                    <div className="inline-block bg-gradient-to-r from-blue-900 to-blue-950 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
                      PASO 04
                    </div>
                    <div className="w-20 h-20 bg-blue-950 rounded-xl flex items-center justify-center mb-6 mx-auto shadow-lg">
                      <i className="ri-truck-line text-4xl text-white"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center">Entrega + Facturación</h3>
                    <p className="text-blue-700 font-semibold text-center mb-4">Recibe tus productos</p>
                    <div className="inline-block bg-white border-2 border-blue-700 text-blue-700 px-4 py-2 rounded-full text-sm font-bold mb-6 w-full text-center">
                      <i className="ri-time-line mr-2"></i>24-48 horas
                    </div>
                    <p className="text-gray-700 leading-relaxed text-center text-sm">
                      Entrega express en Puebla y zona metropolitana. Facturación electrónica automática con todos los requisitos fiscales CFDI 4.0.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Mobile View */}
          <div className="lg:hidden space-y-8">
            {/* Paso 1 Mobile */}
            <div className="transition-all duration-700 opacity-100 translate-x-0">
              <div className="relative">
                <div className="absolute left-10 top-full w-1 h-8 bg-gradient-to-b from-blue-600 to-blue-700 transform translate-y-0"></div>
                <div className="bg-blue-50 rounded-2xl p-6 shadow-lg border-2 border-blue-200">
                  <div className="flex items-start gap-6">
                    <div className="w-20 h-20 bg-blue-700 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg">
                      <i className="ri-file-list-3-line text-3xl text-white"></i>
                    </div>
                    <div className="flex-1">
                      <div className="inline-block bg-gradient-to-r from-blue-600 to-blue-700 text-white px-3 py-1 rounded-full text-xs font-bold mb-3">
                        PASO 01
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-1">Requisición</h3>
                      <p className="text-blue-700 font-semibold mb-3 text-sm">Envía tu lista</p>
                      <div className="inline-block bg-white border-2 border-blue-700 text-blue-700 px-3 py-1 rounded-full text-xs font-bold mb-3">
                        <i className="ri-time-line mr-1"></i>Inmediato
                      </div>
                      <p className="text-gray-700 leading-relaxed text-sm">
                        Comparte tu lista de productos por WhatsApp, correo electrónico o nuestro formulario web. Aceptamos cualquier formato: Excel, PDF, foto o texto.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Paso 2 Mobile */}
            <div className="transition-all duration-700 opacity-100 translate-x-0">
              <div className="relative">
                <div className="absolute left-10 top-full w-1 h-8 bg-gradient-to-b from-blue-700 to-blue-800 transform translate-y-0"></div>
                <div className="bg-blue-100 rounded-2xl p-6 shadow-lg border-2 border-blue-200">
                  <div className="flex items-start gap-6">
                    <div className="w-20 h-20 bg-blue-800 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg">
                      <i className="ri-calculator-line text-3xl text-white"></i>
                    </div>
                    <div className="flex-1">
                      <div className="inline-block bg-gradient-to-r from-blue-700 to-blue-800 text-white px-3 py-1 rounded-full text-xs font-bold mb-3">
                        PASO 02
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-1">Cotización</h3>
                      <p className="text-blue-700 font-semibold mb-3 text-sm">Recibe precios</p>
                      <div className="inline-block bg-white border-2 border-blue-700 text-blue-700 px-3 py-1 rounded-full text-xs font-bold mb-3">
                        <i className="ri-time-line mr-1"></i>24-48 horas
                      </div>
                      <p className="text-gray-700 leading-relaxed text-sm">
                        Buscamos los mejores productos y precios del mercado para ti. Te enviamos una cotización detallada con opciones competitivas, disponibilidad y condiciones de pago adaptadas a tu empresa.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Paso 3 Mobile */}
            <div className="transition-all duration-700 opacity-100 translate-x-0">
              <div className="relative">
                <div className="absolute left-10 top-full w-1 h-8 bg-gradient-to-b from-blue-800 to-blue-900 transform translate-y-0"></div>
                <div className="bg-blue-200 rounded-2xl p-6 shadow-lg border-2 border-blue-200">
                  <div className="flex items-start gap-6">
                    <div className="w-20 h-20 bg-blue-900 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg">
                      <i className="ri-checkbox-circle-line text-3xl text-white"></i>
                    </div>
                    <div className="flex-1">
                      <div className="inline-block bg-gradient-to-r from-blue-800 to-blue-900 text-white px-3 py-1 rounded-full text-xs font-bold mb-3">
                        PASO 03
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-1">Confirmación</h3>
                      <p className="text-blue-700 font-semibold mb-3 text-sm">Aprueba tu pedido</p>
                      <div className="inline-block bg-white border-2 border-blue-700 text-blue-700 px-3 py-1 rounded-full text-xs font-bold mb-3">
                        <i className="ri-time-line mr-1"></i>15 minutos
                      </div>
                      <p className="text-gray-700 leading-relaxed text-sm">
                        Revisa y confirma tu pedido. Ofrecemos múltiples formas de pago: transferencia, efectivo y crédito empresarial hasta 30 días.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Paso 4 Mobile */}
            <div className="transition-all duration-700 opacity-100 translate-x-0">
              <div className="relative">
                <div className="bg-blue-300 rounded-2xl p-6 shadow-lg border-2 border-blue-200">
                  <div className="flex items-start gap-6">
                    <div className="w-20 h-20 bg-blue-950 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg">
                      <i className="ri-truck-line text-3xl text-white"></i>
                    </div>
                    <div className="flex-1">
                      <div className="inline-block bg-gradient-to-r from-blue-900 to-blue-950 text-white px-3 py-1 rounded-full text-xs font-bold mb-3">
                        PASO 04
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-1">Entrega + Facturación</h3>
                      <p className="text-blue-700 font-semibold mb-3 text-sm">Recibe tus productos</p>
                      <div className="inline-block bg-white border-2 border-blue-700 text-blue-700 px-3 py-1 rounded-full text-xs font-bold mb-3">
                        <i className="ri-time-line mr-1"></i>24-48 horas
                      </div>
                      <p className="text-gray-700 leading-relaxed text-sm">
                        Entrega express en Puebla y zona metropolitana. Facturación electrónica automática con todos los requisitos fiscales CFDI 4.0.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Detalles del Proceso */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="text-center mb-16 transition-all duration-1000 opacity-100 translate-y-0">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Detalles del Proceso</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Cada etapa está diseñada para brindarte la mejor experiencia de compra
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Detalle 1 */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 opacity-100 translate-y-0">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-700 to-blue-900 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                <i className="ri-smartphone-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Múltiples Canales de Contacto</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                Envía tu requisición por WhatsApp, correo electrónico, formulario web o llamada telefónica. Elige el canal que más te convenga.
              </p>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">WhatsApp Business</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Email corporativo</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Formulario web</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Teléfono directo</span>
                </li>
              </ul>
            </div>
            
            {/* Detalle 2 */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 opacity-100 translate-y-0">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-700 to-blue-900 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                <i className="ri-price-tag-3-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Cotización Detallada y Transparente</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                Recibe precios competitivos con desglose completo: producto, cantidad, precio unitario, subtotal, IVA y total. Sin sorpresas.
              </p>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Precios actualizados</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Disponibilidad en tiempo real</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Descuentos por volumen</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Opciones de pago</span>
                </li>
              </ul>
            </div>
            
            {/* Detalle 3 */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 opacity-100 translate-y-0">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-700 to-blue-900 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Confirmación Segura</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                Revisa tu pedido antes de confirmar. Modificaciones sin costo adicional. Pago seguro con múltiples opciones.
              </p>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Revisión antes de confirmar</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Modificaciones sin cargo</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Pago seguro</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Crédito empresarial</span>
                </li>
              </ul>
            </div>
            
            {/* Detalle 4 */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 opacity-100 translate-y-0">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-700 to-blue-900 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                <i className="ri-map-pin-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Entrega Rastreable</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                Seguimiento en tiempo real de tu pedido. Entrega programada en el horario que prefieras.
              </p>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Rastreo en tiempo real</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Horario flexible</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Factura CFDI 4.0</span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-blue-700 text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-sm">Soporte post-entrega</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      
      {/* Por Qué Nos Eligen */}
      <section className="py-12 md:py-24 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16 relative z-10">
          <div className="text-center mb-10 md:mb-16 transition-all duration-1000 opacity-100 translate-y-0">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 md:mb-4">Por Qué Nos Eligen</h2>
            <p className="text-base md:text-xl text-white/90 max-w-3xl mx-auto px-4">
              Números que respaldan nuestro compromiso con las empresas mexicanas
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/20 hover:bg-white/15 transition-all duration-500 opacity-100 translate-y-0">
              <div className="inline-block bg-white text-blue-900 px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold mb-4 md:mb-6">
                +250 Productos
              </div>
              <div className="w-14 h-14 md:w-16 md:h-16 bg-white/20 rounded-xl flex items-center justify-center mb-4 md:mb-6 mx-auto">
                <i className="ri-box-3-line text-3xl md:text-4xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4 text-center">Más de 250 Productos</h3>
              <p className="text-white/80 leading-relaxed text-center text-sm md:text-base">
                Contamos con un amplio catálogo de más de 250 productos cuidadosamente seleccionados para cubrir todas las necesidades operativas de tu empresa, todo en un solo proveedor.
              </p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/20 hover:bg-white/15 transition-all duration-500 opacity-100 translate-y-0">
              <div className="inline-block bg-white text-blue-900 px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold mb-4 md:mb-6">
                +150 Marcas
              </div>
              <div className="w-14 h-14 md:w-16 md:h-16 bg-white/20 rounded-xl flex items-center justify-center mb-4 md:mb-6 mx-auto">
                <i className="ri-medal-line text-3xl md:text-4xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4 text-center">Más de 150 Marcas</h3>
              <p className="text-white/80 leading-relaxed text-center text-sm md:text-base">
                Trabajamos con más de 150 marcas líderes del mercado, lo que nos permite ofrecerte siempre la mejor relación calidad-precio y garantizar insumos de primer nivel.
              </p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/20 hover:bg-white/15 transition-all duration-500 opacity-100 translate-y-0">
              <div className="inline-block bg-white text-blue-900 px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold mb-4 md:mb-6">
                98% Satisfacción
              </div>
              <div className="w-14 h-14 md:w-16 md:h-16 bg-white/20 rounded-xl flex items-center justify-center mb-4 md:mb-6 mx-auto">
                <i className="ri-emotion-happy-line text-3xl md:text-4xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4 text-center">98% Satisfacción</h3>
              <p className="text-white/80 leading-relaxed text-center text-sm md:text-base">
                El 98% de nuestros clientes están satisfechos con nuestro servicio. Nuestra prioridad es que tu empresa nunca se detenga por falta de insumos.
              </p>
            </div>
          </div>
          
          <div className="mt-10 md:mt-16 text-center transition-all duration-1000 delay-500 opacity-100 translate-y-0">
            <div className="inline-flex flex-col md:flex-row items-center gap-3 md:gap-4 bg-white/10 backdrop-blur-sm px-6 md:px-8 py-4 rounded-full border border-white/20">
              <i className="ri-verified-badge-line text-2xl md:text-3xl text-white"></i>
              <div className="text-center md:text-left">
                <div className="text-white font-bold text-base md:text-lg">Tu Aliado Estratégico de Suministro</div>
                <div className="text-white/80 text-xs md:text-sm">Respaldando la operación de empresas mexicanas cada día</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Ventajas del Proceso */}
      <section className="py-12 md:py-24 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16">
          <div className="text-center mb-10 md:mb-16 transition-all duration-1000 opacity-100 translate-y-0">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4 px-4">
              Ventajas de Nuestro Proceso
            </h2>
            <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto px-4">
              Beneficios que hacen la diferencia en tu experiencia de compra
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 group opacity-100 translate-y-0">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-blue-700 to-blue-900 rounded-xl flex items-center justify-center mb-5 md:mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className="ri-speed-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 md:mb-3">Rapidez</h3>
              <p className="text-gray-600 leading-relaxed mb-5 md:mb-6 text-sm md:text-base">
                Respuesta en menos de 2 horas y entrega en 24-48 horas en Puebla y zona metropolitana.
              </p>
              <div className="flex items-center gap-3 pt-5 md:pt-6 border-t border-gray-200">
                <div className="text-2xl md:text-3xl font-bold text-blue-700">&lt;2h</div>
                <div className="text-xs md:text-sm text-gray-500">Respuesta</div>
              </div>
            </div>
            
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 group opacity-100 translate-y-0">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-blue-700 to-blue-900 rounded-xl flex items-center justify-center mb-5 md:mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className="ri-money-dollar-circle-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 md:mb-3">Precios Competitivos</h3>
              <p className="text-gray-600 leading-relaxed mb-5 md:mb-6 text-sm md:text-base">
                Los mejores precios del mercado con descuentos por volumen y promociones especiales.
              </p>
              <div className="flex items-center gap-3 pt-5 md:pt-6 border-t border-gray-200">
                <div className="text-2xl md:text-3xl font-bold text-blue-700">15%</div>
                <div className="text-xs md:text-sm text-gray-500">Ahorro promedio</div>
              </div>
            </div>
            
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 group opacity-100 translate-y-0">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-blue-700 to-blue-900 rounded-xl flex items-center justify-center mb-5 md:mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className="ri-customer-service-2-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 md:mb-3">Atención Personalizada</h3>
              <p className="text-gray-600 leading-relaxed mb-5 md:mb-6 text-sm md:text-base">
                Ejecutivo dedicado para empresas. Soporte técnico y asesoría especializada sin costo.
              </p>
              <div className="flex items-center gap-3 pt-5 md:pt-6 border-t border-gray-200">
                <div className="text-2xl md:text-3xl font-bold text-blue-700">24/7</div>
                <div className="text-xs md:text-sm text-gray-500">Disponibilidad</div>
              </div>
            </div>
            
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 group opacity-100 translate-y-0">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-blue-700 to-blue-900 rounded-xl flex items-center justify-center mb-5 md:mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className="ri-bank-card-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 md:mb-3">Crédito Empresarial</h3>
              <p className="text-gray-600 leading-relaxed mb-5 md:mb-6 text-sm md:text-base">
                Línea de crédito hasta 30 días para empresas. Proceso de aprobación en 24 horas.
              </p>
              <div className="flex items-center gap-3 pt-5 md:pt-6 border-t border-gray-200">
                <div className="text-2xl md:text-3xl font-bold text-blue-700">30</div>
                <div className="text-xs md:text-sm text-gray-500">Días de crédito</div>
              </div>
            </div>
            
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 group opacity-100 translate-y-0">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-blue-700 to-blue-900 rounded-xl flex items-center justify-center mb-5 md:mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className="ri-box-3-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 md:mb-3">Amplio Inventario</h3>
              <p className="text-gray-600 leading-relaxed mb-5 md:mb-6 text-sm md:text-base">
                Más de 250 productos en stock. Si no lo tenemos, lo conseguimos en 48 horas.
              </p>
              <div className="flex items-center gap-3 pt-5 md:pt-6 border-t border-gray-200">
                <div className="text-2xl md:text-3xl font-bold text-blue-700">250+</div>
                <div className="text-xs md:text-sm text-gray-500">Productos</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Final */}
      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-8 lg:px-16">
          <div className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 rounded-3xl p-12 lg:p-16 text-center shadow-2xl relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute inset-0"></div>
            </div>
            <div className="relative z-10">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-8">
                <i className="ri-rocket-line text-5xl text-white"></i>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">¿Listo para Empezar?</h2>
              <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
                Envía tu primera requisición ahora y experimenta un proceso de compra rápido, transparente y sin complicaciones
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
                <a
                  href="https://wa.me/+522228121142"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white text-blue-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-2xl"></i>
                  Enviar Requisición por WhatsApp
                </a>
                <Link
                  to="/contacto"
                  className="bg-blue-700 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-blue-600 transition-all duration-300 border-2 border-white shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  Formulario de Contacto
                </Link>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                  <i className="ri-shield-check-line text-3xl text-white mb-2"></i>
                  <div className="text-white font-semibold">Proceso Seguro</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                  <i className="ri-time-line text-3xl text-white mb-2"></i>
                  <div className="text-white font-semibold">Respuesta Rápida</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                  <i className="ri-customer-service-2-line text-3xl text-white mb-2"></i>
                  <div className="text-white font-semibold">Soporte 24/7</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default ComoTrabajamos;